import { IconButton, Tooltip } from '@material-ui/core';
import { useEffect, useMemo, useRef, useState } from 'react';
import {
    CODE_GROUP_ID,
    NOTICE_CHECK_STATUS_CD,
    ROLE,
    SUBJECT_SEARCH_PATH,
    ENROLMENT_REG_STATUS,
    SEMESTER_STUDENT_UNIVERSITY_PATH,
    ENROLMENT_ENABLE_STATUS,
    UNIVERSITY_TYPE,
} from '../../../constant/Constant';
import CodeUtil from '../../../util/CodeUtil';
import { modalType } from '../../../util/ModalUtil';
import PdfViewModal from '../../modal/PdfViewModal';
import SubjectDetailModal from '../../modal/SubjectDetailModal';
import SelectionBox from '../../../component/SelectionBox';
import InputBox from '../../../component/InputBox';
import BreadCrumb from '../../../component/BreadCrumb';
import TimePickerBox from '../../../component/TimePickerBox';
import CautionBox from '../../../component/CautionBox';
import SubjectIcon from '../../../component/icon/SubjectIcon';
import PopupRef from '../../../component/PopupRef';
import ModalRef from '../../../component/ModalRef';
import GridTimeBox from '../../../component/GridTimeBox';
import SessionStorageUtil from '../../../util/SessionStorageUtil';
import { useDispatch, useSelector } from 'react-redux';
import {
    actionEnrolmentAdd,
    actionEnrolmentRemove,
    actionEnrolmentSearch,
    actionInit,
    actionSemesterSearch,
    actionSubjectSearch,
} from '../../../module/body/enrolment/EnrolmentSearchSubjectModule';
import { VIEW_ENROLMENT_SEARCH_SUBJECT } from './../../../constant/ViewConstant';
import SearchButtonBox from '../../../component/buttons/SearchButtonBox';
import AuthenticationUtil from '../../../util/AuthenticationUtil';
import NullCheckUtil from '../../../util/NullCheckUtil';
import EnrolmentCautionModal from '../../modal/EnrolmentCautionModal';
import { actionCheckNoticeSearch } from '../../../module/modal/EnrolmentCautionModule';
import TableBox from '../../../component/TableBox';
import TableNoPageBox from '../../../component/TableNoPageBox';
import { handleNoPageControl } from '../../../module/component/TableNoPageBoxModule';
import { defaultGridData, handleControl, initGrid } from '../../../module/component/TableBoxModule';
import { useLocation, useNavigate } from 'react-router-dom';
import { formatUiDttm, convertTimestampToFormatString } from '../../../util/DateTimeUtil';
import qs from 'qs';
import PathUtil from '../../../util/PathUtil';
import { OpenDetailIcon } from '../../../component/icon/GridIcons';
import StatusTextIconBox from '../../../component/StatusTextIconBox';
import GridButtonBox from '../../../component/buttons/GridButtonBox';
import { blue } from '@material-ui/core/colors';

const ConditionArea = ({
    semesterId,
    userId,
    userNm,
    userUniversityCd,
    userUniversityNm,
    userRoleCd,
    modalRef,
    popupRef,
}) => {
    const location = useLocation();
    const queryData = qs.parse(location.search, { ignoreQueryPrefix: true });
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const [subjectTypeCd, setSubjectTypeCd] = useState();
    const [lessonUniversityCd, setLessonUniversityCd] = useState();
    const [lessonTypeCd, setLessonTypeCd] = useState();
    const [subjectNm, setSubjectNm] = useState();
    const [weekdayCd, setWeekdayCd] = useState();
    const [bgnTime, setBgnTime] = useState();
    const [endTime, setEndTime] = useState();

    const [params, setParams] = useState({});

    // gridData
    const { gridData } = useSelector((state) => state.tableBoxState);
    const { semesterUser } = useSelector((state) => state.enrolmentCautionState);
    const { semester } = useSelector((state) => state.enrolmentSearchSubjectState);

    const isValidParams = (params) => {
        if (Number(params.bgnTime) > Number(params.endTime)) {
            popupRef.current.openInfo('조회조건 시작시간은 종료시간보다 작아야합니다.');
            return false;
        }

        return true;
    };

    useEffect(() => {
        dispatch(
            actionSemesterSearch({
                params: { semesterId },
                callback: () => {
                    popupRef.current.openAlert('학기정보가 존재하지 않습니다. 관리자에게 문의바랍니다.', () => {
                        return function () {
                            if (userRoleCd == ROLE.STUDENT) {
                                navigate(SUBJECT_SEARCH_PATH);
                            }
                        };
                    });
                },
            }),
        );

        dispatch(
            handleControl({
                columns: subjectColumns,
                onRowDoubleClick: onSubjectRowDoubleClick,
                onChangePageInfo: onChangeSubjectPageInfo,
                params,
            }),
        );

        dispatch(
            handleNoPageControl({
                columns: enrolmentColumns,
                onRowDoubleClick: onEnrolmentRowDoubleClick,
                params,
            }),
        );

        queryData.subjectTypeCd && setSubjectTypeCd(queryData.subjectTypeCd);
        queryData.lessonUniversityCd && setLessonUniversityCd(queryData.lessonUniversityCd);
        queryData.lessonTypeCd && setLessonTypeCd(queryData.lessonTypeCd);
        queryData.subjectNm && setSubjectNm(queryData.subjectNm);
        queryData.weekdayCd && setWeekdayCd(queryData.weekdayCd);
        queryData.bgnTime && setBgnTime(queryData.bgnTime);
        queryData.endTime && setEndTime(queryData.endTime);

        onClickSearch({
            userId,
            userNm,
            userUniversityCd,
            userUniversityNm,
            semesterId,
            userUniversityCd,
            subjectTypeCd: queryData.subjectTypeCd,
            lessonUniversityCd: queryData.lessonUniversityCd,
            lessonTypeCd: queryData.lessonTypeCd,
            subjectNm: queryData.subjectNm,
            weekdayCd: NullCheckUtil.isNotNull(queryData.weekdayCd) ? queryData.weekdayCd : '',
            bgnTime: NullCheckUtil.isNotNull(queryData.bgnTime) ? queryData.bgnTime : '',
            endTime: NullCheckUtil.isNotNull(queryData.endTime) ? queryData.endTime : '',
            enrolmentEnableStatusCd: ENROLMENT_ENABLE_STATUS.ENABLED,
            page: NullCheckUtil.isNotNull(queryData.page) ? queryData.page : defaultGridData.page,
            pageSize: NullCheckUtil.isNotNull(queryData.pageSize) ? queryData.pageSize : 10,
        });

        dispatch(actionCheckNoticeSearch({ params: { userId } }));

        return () => {
            dispatch(actionInit());
            dispatch(initGrid());
        };
    }, []);

    useEffect(() => {
        if (userRoleCd == ROLE.STUDENT) {
            if (NullCheckUtil.isNotNull(semester)) {
                var timestamp = new Date().getTime();
                if (semester.enrolmentReqBgnMillis < timestamp && timestamp < semester.enrolmentReqEndMillis) {
                    console.log('수강신청 기간');
                } else {
                    popupRef.current.openAlert(
                        <p>
                            <p>수강신청 가능 기간이 아닙니다.</p>
                            <br />
                            <p style={{ color: '#5479ff' }}>
                                신청기간: {formatUiDttm(semester.enrolmentReqBgnMillis)} ~{' '}
                                {formatUiDttm(semester.enrolmentReqEndMillis)}
                            </p>
                            <br />
                            <p>강의조회 화면으로 이동합니다.</p>
                        </p>,
                        () => {
                            return function () {
                                navigate(SUBJECT_SEARCH_PATH);
                            };
                        },
                    );
                }
            }
        }
    }, [semester]);

    useEffect(() => {
        dispatch(
            handleControl({
                columns: subjectColumns,
                onRowDoubleClick: onSubjectRowDoubleClick,
                onChangePageInfo: onChangeSubjectPageInfo,
                params,
            }),
        );

        dispatch(
            handleNoPageControl({
                columns: enrolmentColumns,
                onRowDoubleClick: onEnrolmentRowDoubleClick,
                params,
            }),
        );
    }, [params, semesterUser]);

    const onChangeSubjectPageInfo = (page, pageSize) => {
        onClickSearch({
            ...params,
            page,
            pageSize,
        });
    };

    const onClickSearch = (params) => {
        onClickSubjectSearch(params);
        onClickSearchEnrolment(params);
    };

    const onClickSubjectSearch = (params) => {
        setParams(params);
        if (isValidParams(params)) {
            dispatch(
                actionSubjectSearch({
                    params,
                    callback: (result) => {
                        if (result.totalCount == 0) {
                            popupRef.current.openAlert('조회된 결과가 없습니다.');
                        }
                    },
                }),
            );
            PathUtil.pushState(location.pathname, params);
        }
    };

    const onClickSearchEnrolment = (params) => {
        dispatch(
            actionEnrolmentSearch({
                params: {
                    semesterId: params.semesterId,
                    userId: params.userId,
                    page: 0,
                    pageSize: 100,
                },
            }),
        );
    };

    const onSubjectRowDoubleClick = (row, params) => {
        modalRef.current.open(
            <SubjectDetailModal
                type={modalType.DETAIL}
                searchParams={{
                    semesterId: row.semesterId,
                    lessonUniversityCd: row.lessonUniversityCd,
                    subjectId: row.subjectId,
                    classNo: row.classNo,
                    universitySubjectId: row.universitySubjectId,
                }}
                callback={() => {
                    onClickSearch(params);
                }}
                modalRef={modalRef}
            />,
            'large',
        );
    };

    const onEnrolmentRowDoubleClick = (row, params) => {
        modalRef.current.open(
            <SubjectDetailModal
                type={modalType.DETAIL}
                searchParams={{
                    semesterId: row.semesterId,
                    lessonUniversityCd: row.lessonUniversityCd,
                    subjectId: row.subjectId,
                    classNo: row.classNo,
                    universitySubjectId: row.universitySubjectId,
                }}
                callback={() => {
                    onClickSearch(params);
                }}
                modalRef={modalRef}
            />,
            'large',
        );
    };

    const handleSubjectfView = (row) => {
        if (NullCheckUtil.isEmpty(row.lessonPlanFileUid)) {
            popupRef.current.openAlert('강의계획서가 등록되어 있지 않습니다.');
        } else {
            modalRef.current.open(
                <PdfViewModal fileUid={row.lessonPlanFileUid} fileSize={row.lessonPlanFileSize} modalRef={modalRef} />,
                'large',
            );
        }
    };

    const doEnrolement = (row, params) => {
        popupRef.current.openWarning(
            <>
                <div>{row.subjectNm}을(를) 수강신청하시겠습니까?</div>
                <div style={{ fontSize: 14, color: 'red' }}>
                    * 개인별 기수강과목을 확인하여 수강신청하기 바랍니다. 상호인정교과목, 기수강과목인정 등 문의는
                    소속대학 학점교류 담당자에게 문의하기 바랍니다.
                </div>
            </>,
            () => {
                return function () {
                    dispatch(
                        actionEnrolmentAdd({
                            data: {
                                semesterId,
                                userId,
                                lessonUniversityCd: row.lessonUniversityCd,
                                subjectId: row.subjectId,
                                classNo: row.classNo,
                                universitySubjectId: row.universitySubjectId,
                            },
                            callback: () => {
                                popupRef.current.openAlert('수강신청이 처리되었습니다.');
                                onClickSearchEnrolment(params);
                            },
                        }),
                    );
                };
            },
        );
    };

    const handleAddEnrolment = (row, params, semesterUser) => {
        if (
            NullCheckUtil.isNull(semesterUser) ||
            (NullCheckUtil.isNotNull(semesterUser) &&
                semesterUser.noticeCheckStatusCd != NOTICE_CHECK_STATUS_CD.CONFIRM)
        ) {
            modalRef.current.open(
                <EnrolmentCautionModal userId={userId} modalRef={modalRef} isEnrolment={true} />,
                'large',
            );
        } else {
            doEnrolement(row, params);
        }
    };

    const handleDeleteEnrolment = (row, params) => {
        popupRef.current.openWarning(`${row.subjectNm}의 수강신청을 취소하시겠습니까?`, () => {
            return function () {
                dispatch(
                    actionEnrolmentRemove({
                        data: {
                            semesterId,
                            userId,
                            lessonUniversityCd: row.lessonUniversityCd,
                            subjectId: row.subjectId,
                            classNo: row.classNo,
                            universitySubjectId: row.universitySubjectId,
                        },
                        callback: () => {
                            popupRef.current.openAlert('수강신청이 취소되었습니다.', () => {
                                return function () {
                                    onClickSearchEnrolment(params);
                                };
                            });
                        },
                    }),
                );
            };
        });
    };

    const onKeyDown = (e) => {
        if (e.key == 'Enter') {
            onClickSearch({
                userId,
                userNm,
                userUniversityCd,
                userUniversityNm,
                semesterId,
                userUniversityCd,
                subjectTypeCd,
                lessonUniversityCd,
                lessonTypeCd,
                subjectNm,
                weekdayCd,
                bgnTime,
                endTime,
                enrolmentEnableStatusCd: ENROLMENT_ENABLE_STATUS.ENABLED,
                page: 0,
                pageSize: gridData.pageSize,
            });
        }
    };

    const subjectColumns = useMemo(
        () => [
            {
                field: 'lessonUniversityCd',
                headerName: '개설대학',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 12,
                renderCell: (params) =>
                    CodeUtil.getCodeName(CODE_GROUP_ID.MAIN_UNIVERSITY, params.row.lessonUniversityCd),
            },
            {
                field: 'subjectTypeCd',
                headerName: '과정구분',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 12,
                renderCell: (params) => CodeUtil.getCodeName(CODE_GROUP_ID.SUBJECT_TYPE, params.row.subjectTypeCd),
            },
            {
                field: 'subjectNm',
                headerName: '교과목',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 15,
            },
            { field: 'classNo', headerName: '분반', headerAlign: 'center', align: 'center', tooltip: true, flex: 6 },
            { field: 'profNm', headerName: '교강사', headerAlign: 'center', align: 'center', tooltip: true, flex: 6 },
            { field: 'creditCnt', headerName: '학점', headerAlign: 'center', align: 'center', tooltip: true, flex: 6 },
            {
                field: 'lessonTypeCd',
                headerName: '수업방식',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 12,
                renderCell: (params) => CodeUtil.getCodeName(CODE_GROUP_ID.LESSON_TYPE, params.row.lessonTypeCd),
            },
            {
                field: 'courseTimes',
                headerName: '강의시간',
                headerAlign: 'center',
                tooltip: true,
                flex: 24,
                renderCell: (params) => <GridTimeBox times={params.row.courseTimes} />,
            },
            {
                field: 'detail',
                headerName: '기능',
                headerAlign: 'center',
                align: 'center',
                flex: 20,
                disableColumnMenu: true,
                hideSortIcons: true,
                disableExport: true,
                renderCell: (item) => (
                    <>
                        <Tooltip title='상세'>
                            <IconButton onClick={() => onSubjectRowDoubleClick(item.row, params)}>
                                <OpenDetailIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title={'강의계획서 보기'}>
                            <IconButton onClick={(e) => handleSubjectfView(item.row)}>
                                <SubjectIcon />
                            </IconButton>
                        </Tooltip>
                        <GridButtonBox
                            title='수강신청'
                            btnStyle='BULE-BORDER'
                            onClick={(e) => handleAddEnrolment(item.row, params, semesterUser)}
                        />
                        {/* <IconButton onClick={(e) => handleAddEnrolment(item.row, params, semesterUser)}>
                                <AddIcon />
                            </IconButton> */}
                    </>
                ),
            },
        ],
        [params, semesterUser],
    );

    const enrolmentColumns = useMemo(
        () => [
            {
                field: 'lessonUniversityCd',
                headerName: '개설대학',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 12,
                renderCell: (params) =>
                    CodeUtil.getCodeName(CODE_GROUP_ID.MAIN_UNIVERSITY, params.row.lessonUniversityCd),
            },
            {
                field: 'subjectTypeCd',
                headerName: '과정구분',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 12,
                renderCell: (params) => CodeUtil.getCodeName(CODE_GROUP_ID.SUBJECT_TYPE, params.row.subjectTypeCd),
            },
            {
                field: 'subjectNm',
                headerName: '교과목',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 15,
            },
            { field: 'classNo', headerName: '분반', headerAlign: 'center', align: 'center', tooltip: true, flex: 6 },
            { field: 'profNm', headerName: '교강사', headerAlign: 'center', align: 'center', tooltip: true, flex: 6 },
            { field: 'creditCnt', headerName: '학점', headerAlign: 'center', align: 'center', tooltip: true, flex: 6 },
            {
                field: 'lessonTypeCd',
                headerName: '수업방식',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 12,
                renderCell: (params) => CodeUtil.getCodeName(CODE_GROUP_ID.LESSON_TYPE, params.row.lessonTypeCd),
            },
            {
                field: 'courseTimes',
                headerName: '강의시간',
                headerAlign: 'center',
                tooltip: true,
                flex: 20,
                renderCell: (params) => <GridTimeBox times={params.row.courseTimes} />,
            },
            {
                field: 'enrolmentRegStatusCd',
                headerName: '수강신청 등록상태',
                headerAlign: 'center',
                align: 'center',
                tooltip: true,
                flex: 15,
                renderCell: (params) => (
                    <StatusTextIconBox
                        codeGroup={CODE_GROUP_ID.ENROLMENT_REG_STATUS}
                        statusCd={params.row.enrolmentRegStatusCd}
                    />
                ),
            },
            {
                field: 'detail',
                headerName: '기능',
                headerAlign: 'center',
                align: 'center',
                flex: 20,
                disableColumnMenu: true,
                hideSortIcons: true,
                disableExport: true,
                renderCell: (item) => (
                    <>
                        <Tooltip title='상세'>
                            <IconButton onClick={() => onSubjectRowDoubleClick(item.row, params)}>
                                <OpenDetailIcon />
                            </IconButton>
                        </Tooltip>
                        <Tooltip title={'강의계획서 보기'}>
                            <IconButton onClick={(e) => handleSubjectfView(item.row)}>
                                <SubjectIcon />
                            </IconButton>
                        </Tooltip>
                        <GridButtonBox
                            title='신청취소'
                            btnStyle='RED-BORDER'
                            onClick={(e) => handleDeleteEnrolment(item.row, params)}
                        />

                        {/* <IconButton onClick={(e) => handleDeleteEnrolment(item.row, params)}>
                                <DeleteIcon />
                            </IconButton> */}
                    </>
                ),
            },
        ],
        [params, semesterUser],
    );

    return (
        <>
            <div className='con-form-wrap'>
                <div className='board-inner'>
                    <div className='board-row'>
                        <div className='lec-check-box'>
                            <div className='form-box-container'>
                                <SelectionBox
                                    title='학기'
                                    value={semesterId}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.SEMESTER)}
                                    onChange={(e) => {}}
                                    disabled
                                    useAll={false}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <SelectionBox
                                    title='개설대학'
                                    w140
                                    value={lessonUniversityCd}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.MAIN_UNIVERSITY).filter(
                                        (code) => code.cd != userUniversityCd,
                                    )}
                                    onChange={(e) => setLessonUniversityCd(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <SelectionBox
                                    title='마이크로디그리 과정'
                                    value={subjectTypeCd}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.SUBJECT_TYPE)}
                                    onChange={(e) => setSubjectTypeCd(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <InputBox
                                    title='교과목'
                                    value={subjectNm}
                                    onChange={(e) => setSubjectNm(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />

                                <SelectionBox
                                    title='수업방식'
                                    w140
                                    value={lessonTypeCd}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.LESSON_TYPE)}
                                    onChange={(e) => setLessonTypeCd(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                            </div>
                            <div className='lec-check-btn'>
                                <SearchButtonBox
                                    title='강의조회'
                                    onClick={(e) =>
                                        onClickSearch({
                                            userId,
                                            userNm,
                                            userUniversityCd,
                                            userUniversityNm,
                                            semesterId,
                                            userUniversityCd,
                                            subjectTypeCd,
                                            lessonUniversityCd,
                                            lessonTypeCd,
                                            subjectNm,
                                            weekdayCd,
                                            bgnTime,
                                            endTime,
                                            page: 0,
                                            pageSize: gridData.pageSize,
                                        })
                                    }
                                />
                            </div>
                        </div>
                    </div>
                    <div className='board-row'>
                        <div className='lec-check-box mt16'>
                            <div className='form-box-container'>
                                <SelectionBox
                                    title='요일'
                                    w140
                                    value={weekdayCd}
                                    options={CodeUtil.getCodes(CODE_GROUP_ID.WEEKDAY)}
                                    onChange={(e) => setWeekdayCd(e.target.value)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <TimePickerBox
                                    title='시작시간'
                                    value={bgnTime}
                                    onChangeTimeString={(timeString) => setBgnTime(timeString)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                                <TimePickerBox
                                    title='종료시간'
                                    value={endTime}
                                    onChangeTimeString={(timeString) => setEndTime(timeString)}
                                    onKeyDown={(e) => onKeyDown(e)}
                                />
                            </div>
                        </div>
                        <CautionBox
                            userId={userId}
                            title='수강신청 유의사항 확인'
                            isEnrolment={true}
                            semesterId={semesterId}
                            semesterNm={semester?.semesterNm}
                        />
                    </div>
                </div>
            </div>
        </>
    );
};

const EnrolmentSearchSubjectView = () => {
    const location = useLocation();
    const queryData = qs.parse(location.search, { ignoreQueryPrefix: true });

    const modalRef = useRef(null);
    const popupRef = useRef(null);
    const semesterId = SessionStorageUtil.getCurrentSemesterId();
    const [userId, setUserId] = useState();
    const [userNm, setUserNm] = useState();
    const [userUniversityCd, setUserUniversityCd] = useState();
    const [userUniversityNm, setUserUniversityNm] = useState();
    const userRoleCd = AuthenticationUtil.getUserRoleCd();
    const navigate = useNavigate();

    useEffect(() => {
        window.scrollTo(0, 0);
        if (userRoleCd != ROLE.STUDENT) {
            setUserId(queryData.userId);
            setUserNm(queryData.userNm);
            setUserUniversityCd(queryData.userUniversityCd);
            setUserUniversityNm(CodeUtil.getCodeName(CODE_GROUP_ID.USER_UNIVERSITY, queryData.userUniversityCd));
        } else {
            setUserId(AuthenticationUtil.getUserId());
            setUserNm(AuthenticationUtil.getUserNm());
            setUserUniversityCd(AuthenticationUtil.getUserUniversityCd());
            setUserUniversityNm(
                CodeUtil.getCodeName(CODE_GROUP_ID.USER_UNIVERSITY, AuthenticationUtil.getUserUniversityCd()),
            );
        }
    }, []);

    const goBack = () => {
        navigate(SEMESTER_STUDENT_UNIVERSITY_PATH);
    };

    return (
        <section className='container'>
            <div className='container-inner'>
                <div className='con-title-wrap conbg01'>
                    <h2 className='con-title'>
                        {userRoleCd == ROLE.STUDENT ? VIEW_ENROLMENT_SEARCH_SUBJECT.title : '교직원 수강신청'}
                    </h2>
                    <p className='con-title-p'>
                        {userRoleCd == ROLE.STUDENT
                            ? VIEW_ENROLMENT_SEARCH_SUBJECT.subTitle
                            : '불가피한 사유로 소속대학 교직원이 수강신청을 진행하는 경우 사용합니다.'}
                    </p>
                </div>
                {userRoleCd == ROLE.STUDENT ? (
                    <div className='sub-nav-wrap'>
                        <BreadCrumb />
                    </div>
                ) : (
                    <div className='user-form-wrap '>
                        <div className='user-form-inner '>
                            <div className='form-space-between'>
                                <div className='form-row'>
                                    <div className='form'>
                                        <div className='text-info'>교직원 수강신청 대상</div>
                                    </div>
                                    <div className='form'>
                                        <div className='text-normal'>{userUniversityNm}</div>
                                    </div>

                                    <div className='form'>
                                        <div className='text-strong'>
                                            {userNm} ({userId})
                                        </div>
                                    </div>
                                </div>

                                <div className='navi-button'>
                                    <button type='button' className='btn blue-border' onClick={() => goBack()}>
                                        목록보기
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
                {userId && (
                    <ConditionArea
                        semesterId={semesterId}
                        userId={userId}
                        userNm={userNm}
                        userUniversityCd={userUniversityCd}
                        userUniversityNm={userUniversityNm}
                        userRoleCd={userRoleCd}
                        modalRef={modalRef}
                        popupRef={popupRef}
                    />
                )}
                <div className='con-tb-wrap'>
                    <div className='con-tb-title  '>
                        <h3 className='tb-tit-name'>강의 목록</h3>
                    </div>
                    <div className='comment-box'>
                        <ul>
                            <li>수강신청 유의사항을 확인 후 수강신청 버튼을 클릭하여 수강신청을 진행하세요.</li>
                            <li>본교 강의는 수강신청할 수 없습니다. 본교의 수강신청 기간에 신청하세요.</li>
                            <li>각 대학별 수강신청 기간중에만 해당 대학 강의 수강신청 및 수강취소가 가능합니다.</li>
                            <li>
                                수업계획서는<span className='ico-memo'></span>버튼을 클릭하여 확인할 수 있습니다.
                            </li>
                        </ul>
                    </div>
                </div>
                <TableBox defaultWide={false} />
                <div className='con-tb-wrap'>
                    <div className='my-course-list'>
                        <div className='con-tb-title'>
                            <h3 className='tb-tit-name'>수강신청 결과</h3>
                        </div>
                        <ul className='comment-box'>
                            <li>수강신청 목록을 확인하고 수강신청 기간 중에는 신청한 과목을 취소할 수 있습니다.</li>
                        </ul>
                    </div>
                </div>
                <TableNoPageBox defaultWide={false} />
            </div>
            <PopupRef ref={popupRef} />
            <ModalRef ref={modalRef} />
        </section>
    );
};

export default EnrolmentSearchSubjectView;
